module.exports = __webpack_public_path__ + "img/7.1051b69b.png";